import { render, staticRenderFns } from "./SnackbarQueue.vue?vue&type=template&id=7aa68265"
import script from "./SnackbarQueue.vue?vue&type=script&lang=ts"
export * from "./SnackbarQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports